{
  "Description": "VA : 00120",
  "RedundantCharacters": " -",
  "ValidationRegex": "^00120$",
  "TestData": {
    "Valid": [
      "00120"
    ],
    "Invalid": [
      "0012",
      "001200"
    ]
  }
}